export interface SegmentedOption {
  value: string;
  label: string;
}

/**
 * A row of exclusive choices — All / staging / production, and the run-status
 * groups. Controlled: the parent owns `value`, and `aria-pressed` is what
 * announces which one is active.
 */
export function Segmented({
  options,
  value,
  onChange,
  label,
}: {
  options: SegmentedOption[];
  value: string;
  onChange: (value: string) => void;
  label: string;
}) {
  return (
    <div className="segmented" role="group" aria-label={label}>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          className={`segmented__btn${o.value === value ? " segmented__btn--active" : ""}`}
          aria-pressed={o.value === value}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
